import { NgModule, LOCALE_ID } from '@angular/core';

import { AppComponent } from './app.component';
import { PoFieldModule, PoModule } from '@po-ui/ng-components';
import { RouterModule } from '@angular/router';
import { PoTemplatesModule } from '@po-ui/ng-templates';
import { AppRoutingModule } from './app-routing.module';

// Import FusionCharts library and chart modules
import * as FusionCharts from 'fusioncharts';
import * as charts from 'fusioncharts/fusioncharts.charts';
import * as FusionTheme from 'fusioncharts/themes/fusioncharts.theme.fusion';
import * as Widgets from 'fusioncharts/fusioncharts.widgets';
import * as Fusion from 'fusioncharts/themes/fusioncharts.theme.fusion'
import * as Ocean from 'fusioncharts/themes/fusioncharts.theme.ocean';
import * as Fint from 'fusioncharts/themes/fusioncharts.theme.fint';
import * as Candy from 'fusioncharts/themes/fusioncharts.theme.candy';
import * as Gammel from 'fusioncharts/themes/fusioncharts.theme.gammel';
import * as Zune from 'fusioncharts/themes/fusioncharts.theme.zune';
import * as Carbon from 'fusioncharts/themes/fusioncharts.theme.carbon';

import { HomeComponent } from './views/home/home.component';
import { LoginComponent } from './views/login/login.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { WelcomeComponent } from './shared/welcome/welcome.component';
import { FilterComponent } from './shared/filter/filter.component';
import { InformativeComponent } from './views/sales-views/informative/informative.component';
import { HourlySalesComponent } from './views/sales-views/hourly-sales/hourly-sales.component';
import { PaymentMethodsComponent } from './views/sales-views/payment-methods/payment-methods.component';
import { BillingDayComponent } from './views/sales-views/billing-day/billing-day.component';
import { BillingValueComponent } from './views/sales-views/billing-value/billing-value.component';
import { SellingProductsComponent } from './views/sales-views/selling-products/selling-products.component';
import { RankingFilialComponent } from './views/sales-views/ranking-filial/ranking-filial.component';
import { TotalSalesComponent } from './views/sales-views/total-sales/total-sales.component';
import { HttpClientModule } from '@angular/common/http';
import { PoLoadingModule } from '@po-ui/ng-components';
import { LoadingIconComponent } from './shared/loading-icon/loading-icon.component';
import { SellingGoalsComponent } from './views/sales-views/selling-goals/selling-goals.component';
import { SalesCompanyComponent } from './views/sales-views/sales-company/sales-company.component';
import { RankingSellersComponent } from './views/sales-views/ranking-sellers/ranking-sellers.component';
import { TopSellingComponent } from './views/sales-views/top-selling/top-selling.component';
import { AuthGuard } from './helpers/auth.guard';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { FusionChartsModule } from 'angular-fusioncharts';
import { FinancialInformativeComponent } from './views/financial-views/financial-informative/financial-informative.component';
import { FinancialPayReceiveComponent } from './views/financial-views/financial-pay-receive/financial-pay-receive.component';
import { FinancialAccountBalanceComponent } from './views/financial-views/financial-account-balance/financial-account-balance.component';
import { FinancialAmountReceivedComponent } from './views/financial-views/financial-amount-received/financial-amount-received.component';
import { FinancialLateCardsComponent } from './views/financial-views/financial-late-cards/financial-late-cards.component';
import { FinancialRankingSuppliersComponent } from './views/financial-views/financial-ranking-suppliers/financial-ranking-suppliers.component';
import { FinancialRankingClientsComponent } from './views/financial-views/financial-ranking-clients/financial-ranking-clients.component';
import { FinancialOpenValueComponent } from './views/financial-views/financial-open-value/financial-open-value.component';
import { FinancialResultValuesComponent } from './views/financial-views/financial-result-values/financial-result-values.component';

import ptBr from '@angular/common/locales/pt';
import { registerLocaleData } from '@angular/common';
import { FinalyOrderClassDayComponent } from './views/manufaturing-views/finaly-order-class-day/finaly-order-class-day.component';
import { FinalyDefectOrderClassDayComponent } from './views/manufaturing-views/finaly-defect-order-class-day/finaly-defect-order-class-day.component';
import { InformativeDefectComponent } from './views/manufaturing-views/informative-defect/informative-defect.component';
import { FinalyOrderTotal15DaysComponent } from './views/manufaturing-views/finaly-order-total15-days/finaly-order-total15-days.component';
import { QuantityOrderClassLocationComponent } from './views/manufaturing-views/quantity-order-class-location/quantity-order-class-location.component';
import { QuantityOrderClassLocationPartComponent } from './views/manufaturing-views/quantity-order-class-location-part/quantity-order-class-location-part.component';
import { ThroughputOrderPlaceComponent } from './views/manufaturing-views/throughput-order-place/throughput-order-place.component';
import { ErrorComponent } from './shared/error/error.component';
import { ModuloComponent } from './views/modelo-view/modulo.component';
import { SalesGroupComponent } from './views/sales-views/sales-group/sales-group.component';
import { SalesFilialComponent } from './views/sales-views/sales-filial/sales-filial.component';
import { BreadcrumbComponent } from './shared/breadcrumb/breadcrumb.component';
import { NotFoundComponent } from './shared/not-found/not-found.component';
import { SalesSallersComponent } from './views/sales-views/sales-sallers/sales-sallers.component';
import { SalesReturnsComponent } from './views/salers-view/sales-returns/sales-returns.component';
import { BestSellingComponent } from './views/salers-view/best-selling/best-selling.component';
import { AverageRevenueComponent } from './views/salers-view/average-revenue/average-revenue.component';
import { PercentageBilledComponent } from './views/salers-view/percentage-billed/percentage-billed.component';
import { InformativeSalersComponent } from './views/salers-view/informative-salers/informative-salers.component';
import { ConditionPendingComponent } from './views/salers-view/condition-pending/condition-pending.component';
import { ConditionalConversionComponent } from './views/salers-view/conditional-conversion/conditional-conversion.component';
import { MainCustomersComponent } from './views/salers-view/main-customers/main-customers.component';
import { BirthdaysDayComponent } from './views/salers-view/birthdays-day/birthdays-day.component';
import { SalesRecordComponent } from './views/salers-view/sales-record/sales-record.component';
import { PendingConditionalsComponent } from './views/salers-view/pending-conditionals/pending-conditionals.component';
import { ModalPersonStatisticsComponent } from './views/salers-view/modal-person-statistics/modal-person-statistics.component';
import { SalesRecordDetailComponent } from './views/salers-view/sales-record-detail/sales-record-detail.component';

registerLocaleData(ptBr);

// @ts-ignore
FusionCharts.options["license"]({
  key: 'UoC3cE-11G-10C1D4C1B7B7C6E5B3F3F2E4F3B9sbdC4E3mmaA-21jA1B3awh1I2J3A4B6B5F5B4F3D3A2F2C6D3C7A3B4wjjH3B5D7jF4D5D3D-8buB6A6E3sudC1G2B1wikB1A4B4B2A21A14B12A4D8D5B4lffB2A5UA5vraA2A1A1pcB2DB2G2yyjC2B2C8D4E3D2G2F3J2B3D8E2B3F4p==',
  creditLabel: false
});

FusionChartsModule.fcRoot(FusionCharts, charts, FusionTheme, Widgets, Fusion, Ocean, Fint, Candy, Gammel, Zune, Carbon);

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    LoginComponent,
    WelcomeComponent,
    FilterComponent,
    InformativeComponent,
    HourlySalesComponent,
    PaymentMethodsComponent,
    BillingDayComponent,
    BillingValueComponent,
    SellingProductsComponent,
    TotalSalesComponent,
    LoadingIconComponent,
    SellingGoalsComponent,
    SalesCompanyComponent,
    RankingSellersComponent,
    TopSellingComponent,
    FinancialInformativeComponent,
    FinancialPayReceiveComponent,
    FinancialAccountBalanceComponent,
    FinancialAmountReceivedComponent,
    FinancialLateCardsComponent,
    FinancialRankingSuppliersComponent,
    FinancialRankingClientsComponent,
    FinancialOpenValueComponent,
    FinancialResultValuesComponent,
    FinalyOrderClassDayComponent,
    FinalyDefectOrderClassDayComponent,
    InformativeDefectComponent,
    FinalyOrderTotal15DaysComponent,
    QuantityOrderClassLocationComponent,
    QuantityOrderClassLocationPartComponent,
    ThroughputOrderPlaceComponent,
    ErrorComponent,
    RankingFilialComponent,
    ModuloComponent,
    NotFoundComponent,
    SalesGroupComponent,
    SalesFilialComponent,
    BreadcrumbComponent,
    SalesSallersComponent,
    InformativeSalersComponent,
    SalesReturnsComponent,
    BestSellingComponent,
    AverageRevenueComponent,
    PercentageBilledComponent,
    ConditionPendingComponent,
    ConditionalConversionComponent,
    MainCustomersComponent,
    BirthdaysDayComponent,
    SalesRecordComponent,
    PendingConditionalsComponent,
    ModalPersonStatisticsComponent,
    SalesRecordDetailComponent
  ],
  imports: [
    HttpClientModule,
    FormsModule,
    BrowserModule,
    BrowserAnimationsModule,
    PoModule,
    RouterModule.forRoot([]),
    PoTemplatesModule,
    PoFieldModule,
    ReactiveFormsModule,
    AppRoutingModule,
    PoLoadingModule,
    FusionChartsModule,
  ],
  providers: [AuthGuard],
  bootstrap: [AppComponent]
})
export class AppModule { }
